// @generated by TypeGen from LogbookApp/AppStatus.swift - DO NOT EDIT

import type { IStatus } from "../LogbookModel/Status"
import type { IRecordingTimeSource } from "../LogbookNavigation/RecordingClock"
import type { INavigationRecordingStatus } from "../LogbookNavigation/StatelessNavigation"
import type { IN2KAGSConfiguration, IN2KAGSStatus, IN2KAISAddressedSafetyMessage, IN2KAISClassAStatic, IN2KAISClassBStaticPartA, IN2KAISClassBStaticPartB, IN2KAISSafetyBroadcastMessage, IN2KAISSarAircraftPosition, IN2KActualPressure, IN2KAlert, IN2KAlertConfiguration, IN2KAlertResponse, IN2KAlertText, IN2KAlertThreshold, IN2KAlertValue, IN2KBatteryConfiguration, IN2KBatteryDC, IN2KBatteryStatus, IN2KChargerStatus, IN2KCourseSpeed, IN2KDSCCallInformation, IN2KDepth, IN2KDistanceLog, IN2KEngine, IN2KEngineDynamic, IN2KEngineStatic, IN2KFluidLevel, IN2KHeading, IN2KHeadingTrackControl, IN2KHumidity, IN2KInverterConfiguration, IN2KInverterStatus, IN2KPosition, IN2KRateOfTurn, IN2KRudder, IN2KSwitchBankStatus, IN2KSystemTime, IN2KTemperatureExtended, IN2KThrusterMotorStatus, IN2KTransmissionDynamic, IN2KTripParametersEngine, IN2KTripParametersVessel, IN2KWind, IN2KWindlassMonitoringStatus, IN2KWindlassOperatingStatus } from "../NMEA/N2K/N2KEntry"
import type { INMEADepth, INMEADistance, INMEAEngine, INMEAHeading, INMEANavigation, INMEATime, INMEAWeather, INMEAWind } from "../NMEA/NMEAEntry"

export interface ILogbookAppN2KData {
  position?: IN2KPosition;
  courseSpeed?: IN2KCourseSpeed;
  depth?: IN2KDepth[];
  distanceLog?: IN2KDistanceLog;
  engine?: IN2KEngine[];
  heading?: IN2KHeading[];
  humidity?: IN2KHumidity;
  pressure?: IN2KActualPressure;
  temperature?: IN2KTemperatureExtended;
  systemTime?: IN2KSystemTime;
  wind?: IN2KWind[];
  tanks?: IN2KFluidLevel[];
  batteries?: IN2KBatteryStatus[];
  batteryDC?: IN2KBatteryDC[];
  batteryConfiguration?: IN2KBatteryConfiguration[];
  chargers?: IN2KChargerStatus[];
  switchBanks?: IN2KSwitchBankStatus[];
  engineDynamic?: IN2KEngineDynamic[];
  windlassOperating?: IN2KWindlassOperatingStatus[];
  windlassMonitoring?: IN2KWindlassMonitoringStatus[];
  agsConfiguration?: IN2KAGSConfiguration[];
  agsStatus?: IN2KAGSStatus[];
  engineStatic?: IN2KEngineStatic[];
  aisClassAStatic?: IN2KAISClassAStatic[];
  aisClassBStaticPartA?: IN2KAISClassBStaticPartA[];
  aisClassBStaticPartB?: IN2KAISClassBStaticPartB[];
  aisSarAircraftPosition?: IN2KAISSarAircraftPosition[];
  aisAddressedSafetyMessage?: IN2KAISAddressedSafetyMessage[];
  aisSafetyBroadcastMessage?: IN2KAISSafetyBroadcastMessage[];
  dscCallInformation?: IN2KDSCCallInformation;
  alerts?: IN2KAlert[];
  alertResponses?: IN2KAlertResponse[];
  alertTexts?: IN2KAlertText[];
  alertConfigurations?: IN2KAlertConfiguration[];
  alertThresholds?: IN2KAlertThreshold[];
  alertValues?: IN2KAlertValue[];
  headingTrackControl?: IN2KHeadingTrackControl;
  rudder?: IN2KRudder[];
  tripParametersVessel?: IN2KTripParametersVessel;
  tripParametersEngine?: IN2KTripParametersEngine[];
  inverterStatus?: IN2KInverterStatus[];
  inverterConfiguration?: IN2KInverterConfiguration[];
  thrusterMotorStatus?: IN2KThrusterMotorStatus[];
  rateOfTurn?: IN2KRateOfTurn;
  transmissionDynamic?: IN2KTransmissionDynamic[];
}

export interface ILogbookAppNMEAData {
  distance?: INMEADistance;
  depth?: INMEADepth[];
  engine?: INMEAEngine[];
  heading?: INMEAHeading[];
  log?: INMEADistance;
  navigation?: INMEANavigation;
  time?: INMEATime;
  weather?: INMEAWeather;
  wind?: INMEAWind[];
  n2k?: ILogbookAppN2KData;
}

export interface ILogbookAppNMEAStatusResult {
  connected: boolean;
  data: ILogbookAppNMEAData;
  error?: string;
  lastReceived?: string;
  shipId?: number;
  connectionStatus: ILogbookAppNMEAConnectionStatus;
  recordingStatus: INavigationRecordingStatus;
  clock?: ILogbookAppRecordingClockStatus;
  liveAlerts?: IStatus[];
  liveAlertTime?: string;
}

export interface ILogbookAppRecordingClockStatus {
  source?: IRecordingTimeSource;
  systemFailed: boolean;
  gpsFailed: boolean;
  blocked: boolean;
}

export interface ILogbookAppSyncStatusResult {
  enabled: boolean;
  lastSync?: string;
  status: ILogbookSyncStatus;
}

export interface ILogbookAppStatusResult {
  internet: ILogbookAppInternetStatus;
  navigation: boolean;
  nmea: ILogbookAppNMEAStatusResult;
  sync: ILogbookAppSyncStatusResult;
  time?: string;
  systemTimezone: number;
  messageChannel?: string;
  version: string;
  date?: number;
  server?: boolean;
}

export enum ILogbookAppInternetStatus {
  connected = "connected",
  failed = "failed",
}

export enum ILogbookAppNMEAConnectionStatus {
  connected = "connected",
  connectionFailed = "connectionFailed",
  connectPending = "connectPending",
  disconnected = "disconnected",
  notConfigured = "notConfigured",
  waitingForData = "waitingForData",
  verifyingConnection = "verifyingConnection",
}

export enum ILogbookSyncStatus {
  uninitialized = "uninitialized",
  failed = "failed",
  initialSyncFailed = "initialSyncFailed",
  initialSyncInProgress = "initialSyncInProgress",
  dataWaiting = "dataWaiting",
  inProgress = "inProgress",
  current = "current",
  paused = "paused",
  selectShip = "selectShip",
  selectShipFailed = "selectShipFailed",
  disconnected = "disconnected",
  resync = "resync",
  transition = "transition",
  sessionExpired = "sessionExpired",
}
